module.exports = __webpack_public_path__ + "static/media/empty-detail.57d5715de8fc75e753ec1ed25fd9c251.svg";